import { Users, X, Heart, Calendar, Shield } from "lucide-react";

export const ANNOUNCEMENTS = [
  {
    priority: "high",
    icon: Users,
    title: "Company All-Hands Meeting",
    category: "MEETING",
    description: "Join us this Friday at 3 PM for quarterly updates and Q4 strategic planning",
    dateAnnounced: "Oct 15, 2025",
    time: "3:00 PM",
    infoLabel: "Meeting Information",
    additionalInfo: "Please ensure you're available and have reviewed the agenda beforehand. The meeting link will be sent via email.",

  },
  {
    priority: "medium",
    icon: Heart,
    title: "New Health Benefits Available",
    category: "BENIFITS",
    description: "Enhanced health coverage options now available for enrollment through the employee portal",
    dateAnnounced: "Oct 12, 2025",
    time: "All Day",
    infoLabel: "Employee Benefits",
    additionalInfo: "Visit the HR portal to review and enroll in the new benefits. Contact HR if you have any questions.",


  },
  {
    priority: "low",
    icon: Calendar,
    title: "Office Closure - Thanksgiving",
    category: "HOLIDAY",
    description: "Offices will be closed Nov 28-29 for the holiday. Enjoy time with your family!",
    dateAnnounced: "Oct 10, 2025",
    time: "Nov 28-29",
    infoLabel: "Holiday Schedule",
    additionalInfo: "The office will be closed during these dates. Emergency support will still be available.",
  },
  {
    priority: "high",
    icon: Shield,
    title: "IT Security Training Required",
    category: "TRAINING",
    description: "All employees must complete mandatory cybersecurity training by Oct 31. Link in your email.",
    dateAnnounced: "Oct 8, 2025",
    time: "Due Oct 31",    
    infoLabel: "Training Required",
    additionalInfo: "This training is mandatory for all employees. Please complete it before the deadline to maintain compliance.",

  },
];